// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const BookmarkIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="BookmarkIcon" ref={forwardedRef} {...props}>
      <path d="M5 4.25a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v13.507l-5-4.79-5 4.79zm1.5.5v9.493L10 10.89l3.5 3.353V4.75z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const BookmarkIcon = /* @__PURE__ */ Object.assign(
  BookmarkIconComponent,
  { displayName: 'BookmarkIcon' },
);
